module.exports = __webpack_public_path__ + "img/selected0-min.ed90bfa7.png";